import {
  ADD_USER_TO_LIST,
  DELETE_USER,
  DELETE_USER_FROM_LIST,
  GET_USERS_LIST,
  HIDE_USERS_LOADING,
  SET_ERROR_USERS_LIST,
  SET_USERS_LIST,
  SHOW_USERS_LOADING,
} from "./actionType";

export const getUsersToList = data => ({
  type: GET_USERS_LIST,
  payload: data,
});

export const setUsersToList = payload => ({
  type: SET_USERS_LIST,
  payload,
});

export const showUsersListLoad = () => ({
  type: SHOW_USERS_LOADING,
});

export const hideUsersListLoad = () => ({
  type: HIDE_USERS_LOADING,
});

export const deleteUser = (id, data = {}) => ({
  type: DELETE_USER_FROM_LIST,
  payload: { id, data },
});

export const setErrorUserList = status => ({
  type: SET_ERROR_USERS_LIST,
  payload: status,
});

export const addUser = (user = {}) => ({
  type: ADD_USER_TO_LIST,
  payload: { user },
});
